import React from 'react';
import OfferCardStat from '../../OfferStat';

const OfferDetailsStats = () => (
  <div className="flex flex-col mt-6">
    <div className="flex flex-row ">
      <div className="flex-1">
        <OfferCardStat title="Views" description="150" />
      </div>
      <div className="flex-1">
        <OfferCardStat title="Sales" description="180" />
      </div>
    </div>
    <div className="flex flex-row mt-4">
      <div className="flex-1">
        <OfferCardStat title="Sales Revenue" description="$1,200" />
      </div>
      <div className="flex-1">
        <OfferCardStat title="Promoter Earnings" description="$10,000" />
      </div>
    </div>
  </div>
);

export default OfferDetailsStats;
